import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'semantic-ui-react';
import './index.css';

/**
 * UI checkbox:
 * Checkbox component from react semantic
 * Parameters (Props):
 * @param string id
 * @param bool radio: Format as a radio element. This means it is an exclusive option
 * @param string label
 * @param string value
 * @param bool checked
 * @param bool disabled
 * @param func onChange
 * @param bool toggle: Format to show an on or off choice.
 * @param string mode
 */
export default class UiCheckbox extends React.PureComponent {
  render() {
    const {
      id,
      radio,
      label,
      value,
      checked,
      onChange,
      disabled,
      toggle,
      mode,
      ...otherProps
    } = this.props;
    let checkbox = (
      <Checkbox
        radio={radio}
        label={label}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        toggle={toggle}
        className={`${mode !== null ? `ui-checkbox ${mode}` : ''}`}
        {...otherProps}
      />
    );
    checkbox = (
      <checkbox.type
        {...checkbox.props}
        {...(id ? { id } : {})}
        {...(value ? { value } : {})}
      />
    );

    return checkbox;
  }
}

UiCheckbox.propTypes = {
  id: PropTypes.string,
  radio: PropTypes.bool,
  label: PropTypes.string,
  value: PropTypes.string,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  toggle: PropTypes.bool,
  mode: PropTypes.string,
};

UiCheckbox.defaultProps = {
  radio: false,
  label: null,
  value: null,
  checked: false,
  disabled: false,
  onChange: null,
  mode: null,
  toggle: false,
};
